<template>
    <!-- <div class="page list_page gray_bg"> -->
    <div>
        <BACK title="運輸媒合詳情"/>
        <template v-if="detailLoading">
            <div class="loading">
                <i class="el-icon-loading"></i>
            </div>
        </template>
        <template v-else>
            <div class="page_padding" v-if="caseDetail">
                <ul class="list">
                    <li class="item box_item--detail">
                        <div class="box_tag">
                            <span class="flag">{{caseDetail.caseType}}</span>
                            <span class="date"><i class="el-icon-time"></i>{{getPostDate(caseDetail.updatedAt)}}</span>
                        </div>
                        <div class="box_content">
                            <el-tag type="danger" effect="dark" style="float: right" v-if="caseDetail.isFinish == 1">
                                已結束
                            </el-tag>
                            <div class="data">{{caseDetail.title}}</div>
                            <div class="place">{{caseDetail.areaFrom}}<i class="el-icon-right"></i>{{caseDetail.areaTo}}
                            </div>
                            <div class="info">
                                <p class="flag">配送日期</p>
                                <p class="txt">{{getDateMode(caseDetail.startDate,caseDetail.endDate)}}</p>
                            </div>
                            <div class="info">
                                <p class="flag">車輛類型</p>
                                <p class="txt">
                                    <span>{{caseDetail.carType}}</span>
                                    <!-- <span class="money"><i>NT$</i>面議</span> -->
                                </p>
                            </div>
                        </div>
                    </li>
                </ul>
                <div class="detail">
                    <p class="tit">內容敘述</p>
                    <p class="content">{{(caseDetail || {}).content}}</p>
                    <p class="content" v-if="(caseDetail || {}).contactName">聯絡人:{{(caseDetail || {}).contactName}}</p>
                    <p class="content" v-if="(caseDetail || {}).contactMemo">聯絡資訊:{{(caseDetail || {}).contactMemo}}</p>
                </div>
                <InFeedAdsense
                    data-ad-layout-key="-fb+5w+4e-db+86"
                    data-ad-client="ca-pub-9879330354493543"
                    data-ad-slot="5365863390">
                </InFeedAdsense>
            </div>
            <div class="footer_btn" v-if="(caseDetail || {}).mySelf">
                <el-button class="item plan" plain :disabled="loading" @click="handleEdit()">編輯</el-button>
                <el-button class="item" type="success" :disabled="loading" @click="handleDelete()"><i
                    class="el-icon-loading" v-if="loading"></i>刪除
                </el-button>
            </div>
        </template>
    </div>
</template>
<script>
    import BACK from '@/components/back.vue'
    import FN from '@/components/fn'
    import {mapActions, mapGetters} from 'vuex'

    export default {
        name: 'detail',
        components: {
            BACK
        },
        mixins: [FN],
        data() {
            return {
                qkSearch: false
            }
        },
        mounted() {
            //取得詳情資料
            this.getDetail()
        },
        computed: {
            ...mapGetters([
                'caseType',
                'searchArea',
                'caseDetail'
            ])
        },
        methods: {
            ...mapActions([
                'FETCH'
            ]),
            getDetail() {
                this.detailLoading = true
                const id = this.$route.params.id
                this.FETCH({
                    key: 'CASE_DETAIL',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.getDetail)
                    }
                    if (!+(res || {}).code) {
                        this.detailLoading = false
                    }
                })
            },
            handleEdit() {
                const id = this.$route.params.id
                // const { href } = this.$router.resolve({name: 'JobEdit', params:{ id: id}})
                // window.open(href, '_self')
                this.$router.push({name: 'CaseEdit', params: {id: id}})
            },
            handleDelete() {
                this.loading = true
                const id = this.$route.params.id
                this.FETCH({
                    key: 'CASE_DELETE',
                    id: id
                }).then((res) => {
                    //需要accToken的驗證
                    if (+(res || {}).code === -3) {
                        this.checkNewToken(this.handleDelete)
                    } else {
                        this.handleResponse(res)
                    }
                })
            },
            //刪除回應
            handleResponse(res) {
                if (!+res.code) {
                    this.$confirm('刪除成功', {
                        showCancelButton: false,
                        type: 'success'
                    })
                        .then(() => {
                            // const { href } = this.$router.resolve({name: 'JobList', params:{ tag: 'my'}})
                            // window.open(href, '_self')
                            this.$router.replace({name: 'Case', params: {tag: 'my'}})
                            this.$parent.handleSearch()
                        })
                } else {
                    this.$confirm(res.message, {
                        showCancelButton: false,
                        type: 'error'
                    })
                }
                this.loading = false
            },
            handleBack() {
                //this.$router.push('/job/my')
                this.$router.replace({name: 'Case'})
                //this.$nextTick(() => this.$root.$emit('back'))
            },
            getDateMode(start, end) {
                if (start && end) {
                    return `${start} - ${end}`
                }
                if (start) {
                    return `${start} 起`
                }
                if (end) {
                    return `至 ${end}`
                }
                return '不限時間'
            }
        }
    }
</script>
